<template>
  <div class="relative">
    <input
      class="w-full border-b-2 border-grey-academy-150 p-1 mt-2 px-2 outline-none
      focus:border-blackish bg-beige-academy-200 items-center flex"
      :type="type"
      :id="id ? id : nameToKebab"
      :name="nameToKebab"
      :value="value"
      @input="$emit('input', $event.target.value )"
      :required="isRequired"
    >
    <label
      class="absolute text-sm text-gray-600 uppercase tracking-widest"
      :for="id ? id : nameToKebab"
    >
      {{ name }}
    </label>
    <span v-if="show" class="italic text-b2c-red-300 text-sm">{{ messageToShow }}</span>
  </div>
</template>

<script>
export default {
  props: {
    id: {},
    name: {},
    value: String,
    type: {
      default: 'text',
    },
    showMessage: Boolean,
    message: String,
    isRequired: Boolean,
  },

  data() {
    return {
      show: this.showMessage,
    };
  },

  watch: {
    value() {
      this.show = false;
      this.$emit('clear');
    },

    showMessage() {
      if (this.message) {
        this.show = this.showMessage;
        return;
      }
      this.show = (this.showMessage && !this.value);
    },
  },

  computed: {
    nameToKebab() {
      return this.toKebab(this.name);
    },
    messageToShow() {
      if (this.message) {
        return this.message;
      }
      return this.$t('input.fillField');
    },
  },

  methods: {
    toKebab(value) {
      return value.split(' ').join('-').toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  pointer-events:none;
  left: .5rem;
  top: 14px;
  transition:0.2s ease all;
}

input {
    transition:0.2s ease all;
}

input:focus ~ label, input:valid ~ label {
  @apply text-black; @apply font-normal;
  top: -15px;
}
</style>
